import { createApp } from 'vue'
import { createAuth0 } from '@auth0/auth0-vue'
import auth0WorkerUrl from '@auth0/auth0-spa-js/dist/auth0-spa-js.worker.production.js?url&no-inline'
import App from './App.vue'
import router from './router.js'
import { i18nPlugin } from './i18n.js'
import './styles.css'

const app = createApp(App).use(router).use(i18nPlugin)

const localDevelopmentAuth = import.meta.env.VITE_LOCAL_AUTH === 'true' && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
if (import.meta.env.VITE_DEMO_MODE !== 'true' && !localDevelopmentAuth) {
  app.use(createAuth0({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/admin`,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    },
    cacheLocation: 'memory',
    useRefreshTokens: true,
    workerUrl: auth0WorkerUrl,
  }))
}

app.mount('#app')
